import { render, staticRenderFns } from "./PlainTextCourseTemplate.vue?vue&type=template&id=0ef8f2d4&scoped=true&"
import script from "./PlainTextCourseTemplate.vue?vue&type=script&lang=js&"
export * from "./PlainTextCourseTemplate.vue?vue&type=script&lang=js&"
import style0 from "./PlainTextCourseTemplate.vue?vue&type=style&index=0&id=0ef8f2d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef8f2d4",
  null
  
)

export default component.exports